export enum BaseModalSize {
  Small = '35vw',
  Large = '50vw',
  ExtraLarge = '70vw',
}
